import { useSelector } from "react-redux";
import {
  ReviewPage as CoreReviewPage,
  FlightShopSelectors,
  type ReviewPageComponentProps,
} from "@b2bportal/core-flights";
import { useModuleBEM } from "@b2bportal/core-themes";
import { CoreFlightsComponent, Funnel } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  PremierDestinationBanner,
  usePremierDestinationPromotion,
} from "@hsbc/portal";
import styles from "./styles.module.scss";

export const ReviewPage = (props: ReviewPageComponentProps) => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, CoreFlightsComponent.ReviewPage);

  const destinationCountryCode = useSelector(
    FlightShopSelectors.getDestinationCountryCode
  );
  const originCountryCode = useSelector(
    FlightShopSelectors.getOriginCountryCode
  );

  const {
    activePremierDestinations: { flights: activePremierDestinations },
    enabledPromotions: { flights: isFlightsPremierDestinationEnabled },
  } = usePremierDestinationPromotion();

  return (
    <CoreReviewPage {...props} className={block}>
      {isFlightsPremierDestinationEnabled && (
        <div className={cn("premier-destination-banner")}>
          <PremierDestinationBanner
            funnel={Funnel.Air}
            title={t("premierDestinations.reviewBanner")}
            activePremierDestinations={activePremierDestinations}
            countryCode={[originCountryCode, destinationCountryCode]}
          />
        </div>
      )}
    </CoreReviewPage>
  );
};
